import { useContext } from 'react'

import { RequestProfileTabEmailsViewTypeContext } from '../../RequestProfileTabEmails.contexts'

export function useRequestProfileTabEmailsViewTypeContext() {
  return useContext(RequestProfileTabEmailsViewTypeContext)
}
